import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { useMergedRefs } from "shared/lib/useMergedRefs"
import { IconSize } from "shared/types/Icon"
import { Button } from "shared/ui/buttons/Button"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { TabBarScrollContext } from "./TabBarScrollGroup"

export interface TabBarArrowRightProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const TabBarArrowRight = React.memo(
  React.forwardRef<HTMLButtonElement, TabBarArrowRightProps>(
    ({ className, ...rest }, ref) => {
      const { t } = useTranslation()
      const { canScrollRight, scrollRight, hasOverflow, arrowRightRef } =
        useContext(TabBarScrollContext)

      const mergedRef = useMergedRefs(ref, arrowRightRef)

      const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        rest.onClick?.(e)
        scrollRight()
      }

      // Don't render if no overflow
      if (!hasOverflow) {
        return null
      }

      return (
        <Button
          ref={mergedRef}
          variant="tertiary"
          onClick={handleClick}
          disabled={!canScrollRight}
          {...rest}
          aria-hidden
          tabIndex={-1}
          aria-label={rest["aria-label"] || t("General.Next")}
          className={classNames(
            "btn--icon-only",
            "tab-bar__arrow tab-bar__arrow--right",
            className
          )}
        >
          <Icon name={IconName.SMALL_CARET_RIGHT} size={IconSize.XS} />
        </Button>
      )
    }
  )
)

TabBarArrowRight.displayName = "TabBar.ArrowRight"
